import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FrontSettingsService } from '../../../services/front-settings.service';
import { FRONTSETTINGS } from '../../../interfaces/front-settings.interface';

@Component({
  selector: 'app-contact-floating-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contact-floating-button.component.html',
  styleUrl: './contact-floating-button.component.css'
})
export class ContactFloatingButtonComponent {
  showButtons: boolean = false;
  enableFloatingButton = false;
  allowedRoutes = ['/', '/home'];
  frontSettings: FRONTSETTINGS = {}
  showPopup = false;



  constructor(private router: Router,
    private _frontSettingsService: FrontSettingsService
  ) {

  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.enableControls();
      }
    });
    this.enableControls();

    this._frontSettingsService.frontSettings$.subscribe(settings => {
      this.frontSettings = settings;
    });

  }

  enableControls() {
    this.enableFloatingButton = !this.allowedRoutes.includes(this.router.url);
  }

  toggleButtons() {
    this.showButtons = !this.showButtons;
  }

  togglePopup() {
    this.showPopup = !this.showPopup;
  }
}
